<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="dedication"></a><a id="page_v"></a>For Samir, Kim, Kendis, Kerwin, and Kershaun<br/><em>It’s a family affair</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c0a07d3c